import axiosInstance from "./axiosInstance";

export const DEFAULT_DELIVERY_METHODS = Object.freeze({
  novaPoshtaBranch: true,
  novaPoshtaLocker: true,
  novaPoshtaCourier: true,
  kyivCourier: false,
});
export const DEFAULT_NOVA_POSHTA_SETTINGS = Object.freeze({
  branchFreeDeliveryThreshold: 2500,
  courierFreeDeliveryThreshold: 3000,
});
export const DEFAULT_DELIVERY_SETTINGS = Object.freeze({
  deliveryMethods: DEFAULT_DELIVERY_METHODS,
  novaPoshta: DEFAULT_NOVA_POSHTA_SETTINGS,
});

const positiveNumberOr = (value, fallback) =>
  Number.isFinite(Number(value)) && Number(value) > 0 ? Number(value) : fallback;

export const normalizeDeliveryMethods = (deliveryMethods = {}) => ({
  novaPoshtaBranch:
    typeof deliveryMethods.novaPoshtaBranch === "boolean"
      ? deliveryMethods.novaPoshtaBranch
      : DEFAULT_DELIVERY_METHODS.novaPoshtaBranch,
  novaPoshtaLocker:
    typeof deliveryMethods.novaPoshtaLocker === "boolean"
      ? deliveryMethods.novaPoshtaLocker
      : DEFAULT_DELIVERY_METHODS.novaPoshtaLocker,
  novaPoshtaCourier:
    typeof deliveryMethods.novaPoshtaCourier === "boolean"
      ? deliveryMethods.novaPoshtaCourier
      : DEFAULT_DELIVERY_METHODS.novaPoshtaCourier,
  kyivCourier:
    typeof deliveryMethods.kyivCourier === "boolean"
      ? deliveryMethods.kyivCourier
      : DEFAULT_DELIVERY_METHODS.kyivCourier,
});

export const normalizeNovaPoshtaSettings = (novaPoshta = {}) => ({
  branchFreeDeliveryThreshold: positiveNumberOr(
    novaPoshta.branchFreeDeliveryThreshold,
    DEFAULT_NOVA_POSHTA_SETTINGS.branchFreeDeliveryThreshold
  ),
  courierFreeDeliveryThreshold: positiveNumberOr(
    novaPoshta.courierFreeDeliveryThreshold,
    DEFAULT_NOVA_POSHTA_SETTINGS.courierFreeDeliveryThreshold
  ),
});

export const normalizeDeliverySettings = (data = {}) => ({
  deliveryMethods: normalizeDeliveryMethods(data.deliveryMethods),
  novaPoshta: normalizeNovaPoshtaSettings(data.novaPoshta),
});

export const getDeliverySettings = async () => {
  const { data } = await axiosInstance.get("/site-settings/delivery");
  return normalizeDeliverySettings(data);
};

export const formatUah = (value) =>
  `${new Intl.NumberFormat("uk-UA", { maximumFractionDigits: 2 }).format(
    positiveNumberOr(value, 0)
  )} грн`;

const normalizeMethod = (method) => String(method || "").toLowerCase();

export const getNovaPoshtaFreeDeliveryThreshold = (
  deliveryMethod,
  novaPoshta = DEFAULT_NOVA_POSHTA_SETTINGS
) => {
  const method = normalizeMethod(deliveryMethod);
  const settings = normalizeNovaPoshtaSettings(novaPoshta);
  const isNovaPoshtaCourier =
    method.includes("courier-nova-poshta") ||
    /кур['’ʼ]єром нової пошти/u.test(method);
  if (isNovaPoshtaCourier) return settings.courierFreeDeliveryThreshold;
  const isBranchOrLocker =
    method === "branch" ||
    method === "locker" ||
    method.includes("відділення") ||
    method.includes("поштомат");
  if (isBranchOrLocker) return settings.branchFreeDeliveryThreshold;
  return null;
};

export const isNovaPoshtaFreeDeliveryEligible = (
  deliveryMethod,
  amount,
  novaPoshta = DEFAULT_NOVA_POSHTA_SETTINGS
) => {
  const threshold = getNovaPoshtaFreeDeliveryThreshold(deliveryMethod, novaPoshta);
  return Boolean(threshold && Number(amount || 0) >= threshold);
};
